import FooterControl from '@/components/FooterControl.vue';

export default {
  name: 'template-detail',
  components: { FooterControl },
  data() {
    return {
      type: this.$route.query.type,
      id: this.$route.query.id,
      tempType: parseInt(this.$route.query.tempType, 10),
      datas: {},
      tableData: [],
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    getData() {
      console.log(this.tempType);
      switch (this.tempType) {
        case 1: this.getChineseDrugRecipe();
          break;
        case 2: this.getDrugRecipe();
          break;
        case 4: this.getInfusionRecipe();
          break;
        case 7: this.getStickingDrugGroupRecipe();
          break;
        default:
          break;
      }
    },
    // 查询中药处方模板详情
    getChineseDrugRecipe() {
      this.$api.clinicManagement.getChineseDrugRecipe({
        templateId: this.$route.query.id,
      }).then((res) => {
        console.log(res);
        this.datas = res;
      });
    },
    // 西药处方模板详情查询
    getDrugRecipe() {
      this.$api.clinicManagement.getDrugRecipe({
        templateId: this.$route.query.id,
      }).then((res) => {
        console.log(res);
        this.datas = res;
      });
    },
    // 查询输液处方模板详情
    getInfusionRecipe() {
      this.$api.clinicManagement.getInfusionRecipe({
        templateId: this.$route.query.id,
      }).then((res) => {
        console.log(res);
        this.datas = res;
      });
    },
    // 查询敷贴处方模板详情
    getStickingDrugGroupRecipe() {
      this.$api.clinicManagement.getStickingDrugGroupRecipe({
        templateId: this.$route.query.id,
      }).then((res) => {
        console.log(res);
        this.datas = res;
      });
    },
    goEdit() {
      let link = 'perscriptionTemplateAddCn';
      // 模板类型
      switch (this.tempType) {
        case 1:
          link = 'perscriptionTemplateAddCn';
          break;
        case 2: link = 'perscriptionTemplateAddCom';
          break;
        case 4: link = 'perscriptionTemplateAddInfusion';
          break;
        case 7: link = 'perscriptionTemplateAddSti';
          break;
        default: link = '';
          break;
      }
      // state模式： edit 编辑 add 添加  type：0 个人处方 1 诊所处方
      this.$router.push({ path: link, query: { state: 'edit', type: this.type, id: this.id } });
    },
  },
  mounted() {
    this.getData();
  },
};
